import { c as _c } from "react/compiler-runtime";
import { DEFAULT_PROJECTS_SORT_BY } from "@components/projects/projects-sort-constants";
import { isProjectsSortBy } from "@components/projects/projects-sort-utils";
import { useFetchNextProjectsPage } from "@hooks/projects/use-fetch-next-projects-page";
import { useFetchProjectsOnQueryChange } from "@hooks/projects/use-fetch-projects-on-query-change";
import { useProjectsSearchQuery } from "@hooks/projects/use-projects-search-query";
import { useSubjectsSortByQuery } from "@hooks/use-subjects-sort-by-query";
import { fetchingProjectsFlagsSelector, projectsListSelector } from "@store/projects/projects-selector";
import { getListType } from "@store/projects/projects-slice-utils";
import { useAppSelector } from "@store/store-helper";
/** Custom hook that handles fetching projects */
export function useFetchProjects(t0) {
  const $ = _c(33);
  const {
    companyId,
    projectArchivingState,
    groupId,
    isEnabled: t1
  } = t0;
  const isEnabled = t1 === undefined ? true : t1;
  const {
    isFetchingProjects
  } = useAppSelector(fetchingProjectsFlagsSelector);
  const {
    search,
    isDebouncingSearch
  } = useProjectsSearchQuery();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      defaultSort: DEFAULT_PROJECTS_SORT_BY,
      isValidSort: isProjectsSortBy
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    sortBy,
    setSortBy
  } = useSubjectsSortByQuery(t2);
  let t3;
  let t4;
  if ($[1] !== companyId || $[2] !== groupId || $[3] !== projectArchivingState || $[4] !== search || $[5] !== sortBy) {
    const listType = getListType({
      companyId,
      projectArchivingState,
      search,
      sortBy,
      groupId
    });
    t3 = useAppSelector;
    t4 = projectsListSelector(listType);
    $[1] = companyId;
    $[2] = groupId;
    $[3] = projectArchivingState;
    $[4] = search;
    $[5] = sortBy;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  const {
    projects,
    nextPageCursor,
    hasFetchedFirstPage,
    totalCount
  } = t3(t4);
  let t5;
  if ($[8] !== companyId || $[9] !== groupId || $[10] !== isEnabled || $[11] !== projectArchivingState || $[12] !== search || $[13] !== sortBy) {
    t5 = {
      companyId,
      projectArchivingState,
      sortBy,
      search,
      groupId,
      isEnabled
    };
    $[8] = companyId;
    $[9] = groupId;
    $[10] = isEnabled;
    $[11] = projectArchivingState;
    $[12] = search;
    $[13] = sortBy;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useFetchProjectsOnQueryChange(t5);
  let t6;
  if ($[15] !== companyId || $[16] !== groupId || $[17] !== nextPageCursor || $[18] !== projectArchivingState || $[19] !== search || $[20] !== sortBy) {
    t6 = {
      companyId,
      projectArchivingState,
      sortBy,
      nextPageCursor,
      search,
      groupId
    };
    $[15] = companyId;
    $[16] = groupId;
    $[17] = nextPageCursor;
    $[18] = projectArchivingState;
    $[19] = search;
    $[20] = sortBy;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const loadMoreProjects = useFetchNextProjectsPage(t6);
  let t7;
  if ($[22] !== hasFetchedFirstPage || $[23] !== isDebouncingSearch || $[24] !== isFetchingProjects || $[25] !== loadMoreProjects || $[26] !== nextPageCursor || $[27] !== projects || $[28] !== search || $[29] !== setSortBy || $[30] !== sortBy || $[31] !== totalCount) {
    t7 = {
      projects,
      isFetchingProjects,
      hasFetchedFirstPage,
      nextPageCursor,
      sortBy,
      setSortBy,
      search,
      isDebouncingSearch,
      loadMoreProjects,
      totalCount
    };
    $[22] = hasFetchedFirstPage;
    $[23] = isDebouncingSearch;
    $[24] = isFetchingProjects;
    $[25] = loadMoreProjects;
    $[26] = nextPageCursor;
    $[27] = projects;
    $[28] = search;
    $[29] = setSortBy;
    $[30] = sortBy;
    $[31] = totalCount;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
}